import type { ReportDataTableColumn } from '../../components/ReportDataTable'
import { formatAmount } from '@/lib/utils/formatters'
import type { ConfiguredReportReportRow } from '../../types/pages'
import { display, applicantLink, statusLabel } from '../../utils/configuredReportFormatters'

export const dynamicPricingColumns: ReportDataTableColumn<ConfiguredReportReportRow, string>[] = [
  {
    id: 'applicant_id',
    label: 'Applicant ID',
    sortKey: 'applicant_id',
    render: (row) => applicantLink(row.applicant_id),
  },
  {
    id: 'name',
    label: 'Resident Name',
    sortKey: 'first_name',
    render: (row) =>
      display(row.resident_name ?? row.name ?? row.applicant_name),
  },
  {
    id: 'application_status',
    label: 'Application Status',
    sortKey: 'applicant_status',
    render: (row) =>
      statusLabel(row.applicant_status ?? row.application_status),
  },
  {
    id: 'company_name',
    label: 'Company',
    sortKey: 'company_name',
    render: (row) => display(row.company_name),
  },
  {
    id: 'property_name',
    label: 'Property',
    sortKey: 'property_name',
    render: (row) => display(row.property_name),
  },
  {
    id: 'city',
    label: 'City',
    sortKey: 'property_city',
    render: (row) => display(row.city ?? row.property_city),
  },
  {
    id: 'state',
    label: 'State',
    sortKey: 'property_state',
    render: (row) => display(row.state ?? row.property_state),
  },
  {
    id: 'rent_amount',
    label: 'Rent Amount',
    sortKey: 'rent_amount',
    render: (row) => formatAmount(row.rent_amount as string | number),
  },
  {
    id: 'equifax_score',
    label: 'Highest Credit Score',
    sortKey: 'equifax_score',
    render: (row) => display(row.equifax_score),
  },
  {
    id: 'risk_score',
    label: 'Highest Ninja Score',
    sortKey: 'risk_score',
    render: (row) => display(row.risk_score),
  },
  {
    id: 'income_rent_ratio',
    label: 'Income/Rent Ratio',
    sortKey: 'income_rent_ratio',
    render: (row) =>
      display(row.combined_income_rent_ratio ?? row.income_rent_ratio),
  },
  {
    id: 'job_duration',
    label: 'Job Duration',
    sortKey: 'job_duration',
    render: (row) => display(row.job_duration_format ?? row.job_duration),
  },
  {
    id: 'rental_status',
    label: 'Rental Status',
    sortKey: 'rental_status',
    render: (row) => display(row.rental_status),
  },
]
